import { z } from 'zod';
import { autoRedemptionRuleModelSchema } from './auto-redemption-rule.schema';
import { localeModelSchema } from './locale.schema';
import {
  currencyModelSchema,
  loyaltyCurrencyModelSchema,
} from './loyalty-currency.schema';
import { loyaltyProgramCapabilityModelSchema } from './loyalty-program-capability.schema';
import { loyaltyProgramModelSchema } from './loyalty-program.schema';
import { rewardsProgramModelSchema } from './reward-program.schema';
import { roundingPreferenceModelSchema } from './rounding-preference.schema';
import {
  cashTransferRateModelSchema,
  pointsTransferRateModelSchema,
} from './transfer-rate.schema';

export const pointsPercentageConfigSchema = z.object({
  giftCard: z.number().nullable(),
  merchandise: z.number().nullable(),
});

export const bootstrapResponseSchema = z.object({
  data: z.object({
    id: z.string(),
    type: z.literal('bootstrap'),
    relationships: z.object({
      currencies: z.object({
        data: z.array(
          z.object({
            id: z.string(),
            type: z.literal('currency'),
          }),
        ),
      }),
      locales: z.object({
        data: z.array(
          z.object({
            id: z.string(),
            type: z.literal('locale'),
          }),
        ),
      }),
      loyaltyCurrencies: z.object({
        data: z.array(
          z.object({
            id: z.string(),
            type: z.literal('loyalty_currency'),
          }),
        ),
      }),
      loyaltyPrograms: z.object({
        data: z.array(
          z.object({
            id: z.string(),
            type: z.literal('loyalty_program'),
          }),
        ),
      }),
      rewardsPrograms: z.object({
        data: z.array(
          z.object({
            id: z.string(),
            type: z.literal('rewards_program'),
          }),
        ),
      }),
      capabilities: z
        .object({
          data: z.array(
            z.object({
              id: z.string(),
              type: z.literal('capability'),
            }),
          ),
        })
        .optional(),
      transferRates: z.object({
        data: z.array(
          z.object({
            id: z.string(),
            type: z.union([
              z.literal('points_transfer_rate'),
              z.literal('cash_transfer_rate'),
            ]),
          }),
        ),
      }),
    }),
    attributes: z.object({
      maxPointsPercentage: pointsPercentageConfigSchema,
      minPointsPercentage: pointsPercentageConfigSchema,
      timeZoneOffset: z.string(),
      timeZoneOffsetInMinutes: z.number(),
      autoRedemptionRules: z
        .array(
          z.object({
            attributes: autoRedemptionRuleModelSchema,
          }),
        )
        .optional(),
      roundingPreferences: roundingPreferenceModelSchema,
      paymentProcessingFee: z.object({
        fixed: z.number(),
        percentage: z.number(),
      }),
    }),
  }),
  included: z.array(
    z.discriminatedUnion('type', [
      currencyModelSchema,
      localeModelSchema,
      loyaltyCurrencyModelSchema,
      loyaltyProgramModelSchema,
      loyaltyProgramCapabilityModelSchema,
      rewardsProgramModelSchema,
      cashTransferRateModelSchema,
      pointsTransferRateModelSchema,
    ]),
  ),
});
